module.exports = __webpack_public_path__ + "static/media/no-photo-BLACK.3c001953.png";